import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import PriceBlock from '../../base_price-block/component';
import { TitleAndSubtitle, ProductImage, Badge, Rating } from 'audamatic-ui';
import Link from '../../base_link/component';

import './styles/styles.scss';


/**
 * The ankeiler Small is a variant of ankeiler (component).
 *
 * This variant shows a tile with a small image and the prices for the product.
 */
class AnkeilerSmall extends Component {
  constructor(props) {
    super(props);
    this.pushGoogleTags = this.pushGoogleTags.bind(this);
    this.ankeilerRef = createRef();
    this.anchorRef = createRef();
  }

  get product() {
    return  this.props.product;
  }

  get store() {
    return this.props.store;
  }

  get title() {
    return this.props.title;
  }

  get startURL() {
    return this.store.urls.start || '';
  }

  get pathName() {
    const currPath = window.location.pathname;
    return ((currPath === '/') || (this.startURL.includes(currPath)))
      ? 'Home' : `${window.location.pathname}`;
  }

  get promotionObject() {
    return {
      title: `${this.props.list || 'Ankeiler small'}`,
      name: `${this.props.list} - ${this.pathName}`,
      creative: (this.props.images && this.props.images.Image) || '',
      'component-type': this.props['component-type'],
      variant: this.props.variant,
      url: this.url,
    };
  }

  get type() {
    return this.product.type.toLowerCase();
  }

  get image() {
    return this.product.thumbnail;
  }

  pushGoogleTags() {
    this.props.googleTagMethods()
      .pushProductGoogleTag(this.props);
  }

  render() {
    const { name, rating = 0, url } = this.product;
    const  { badgeValue, infoBlock, hideRating = false } = this.props;

    return (
      <div
        className="ankeiler-small"
        ref={this.ankeilerRef}
      >
        <div className="image wrapper">
          <Link to={url} title={name} onClick={this.pushGoogleTags}>
            <div className="product-image-wrapper">
              <ProductImage
                product={this.product}
                badge={badgeValue && <Badge number={badgeValue} size="small"/>}
                maxHeight={175}
              />
            </div>
          </Link>
          <div className="details haslink">
            <TitleAndSubtitle
              title={this.title}
              subtitle={this.product.personsLinks}
            />
          </div>
          {!hideRating && (
            <div className="ankeiler-rating">
              {!!rating && (
                <Rating rating={rating} />
              )}
            </div>
          )}
          <PriceBlock product={this.product} store={this.store} onePrice={this.props.onePrice} />
        </div>
        <div className="ankeiler-anchor" ref={this.anchorRef}>{infoBlock}</div>
      </div>
    );
  }
}

AnkeilerSmall.propTypes = {
  /**
   * The type of rendered Ankeiler
   */
  variant: PropTypes.string,
  /**
   * The name of the product
   */
  name: PropTypes.string,
  /**
   * The url where to link to
   */
  url: PropTypes.string,
  /**
   * The image object with Thumbnail and Image
   */
  images: PropTypes.shape({
    Thumbnail: PropTypes.string,
    Image: PropTypes.string,
  }),
  /**
   * Pricing object.
   */
  price: PropTypes.shape({
    regular: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.array]),
  }),
  /**
   * Function that returns an object with
   * Google Tags methods
   */
  googleTagMethods: PropTypes.func,
  pushPromotionGoogleTag: PropTypes.func,
  pushProductGoogleTag: PropTypes.func,
  'image-shadow': PropTypes.bool,
  store: PropTypes.object,
  list: PropTypes.string,
  'component-type': PropTypes.string,
  onePrice: PropTypes.bool,
  hideRating: PropTypes.bool,
  badgeValue: PropTypes.number,
  /**
   * Info block component
   */
  infoBlock: PropTypes.node,
  product: PropTypes.object,
  title: PropTypes.object,
};


export default AnkeilerSmall;
